let boxEmailInput = document.getElementById("login-email");
let smartBoxEmailInput = document.getElementById("smart-login-email-box");
let emailInput = document.getElementById("email");
let smartLoginEmailInput = document.getElementById("email-smart");
let emailFeedback = document.getElementById("invalid-feedback-email");
let smartEmailFeedback = document.getElementById(
  "invalid-feedback-smart-email"
);
let smartTokenFeedback = document.getElementById(
  "invalid-feedback-smart-token"
);

let passwordInput = document.getElementById("password");
let passwordFeedback = document.getElementById("invalid-feedback-password");

let changeUserName = document.getElementById("change-username-text");

let loginFormEmail = document.getElementById("login-form-email");
let smartloginFormEmail = document.getElementById("login-form-email-smart");
let loginEmailBtn = document.getElementById("login-email-btn");
let smartloginEmailBtn = document.getElementById("smart-login-email-btn");
let smartloginEmailBtnValue = document.getElementById("button__text");
let smartloginEmailBtnNext = document.querySelector(".button__text_smart");

let boxLoginFormPhone = document.getElementById("login-phone");
let loginFormPhone = document.getElementById("login-form-phone");
let loginPhoneBtn = document.getElementById("login-phone-btn");

let phoneInput = document.getElementById("phone");
let phoneFeedback = document.getElementById("invalid-feedback-phone");

let tokenInput = document.getElementById("token");
let tokenFeedback = document.getElementById("invalid-feedback-token");

let phoneStep = document.getElementById("phone-step");
let tokenStep = document.getElementById("token-step");
let smartTokenStep = document.getElementById("smart-token-step");
let smartToken = document.getElementById("smart-token");

let multipleUsersStep = document.getElementById("multiple-users-step");

let accountCards = document.getElementById("account-cards");
let selectedUserId = undefined;

let codeSentMessage = document.getElementById("code-sent-message");
// otp
let codeBox1 = document.querySelectorAll(".codeBox1");
let codeBox2 = document.querySelectorAll(".codeBox2");
let codeBox3 = document.querySelectorAll(".codeBox3");
let codeBox4 = document.querySelectorAll(".codeBox4");
let phoneOrEmailOTP = null;
let OTPdigits = null;

let loginPhoneStep = "phone";

let defaultTimer = 60;
let timer = defaultTimer;
let timerInterval;

$(document).on("click", ".login-with-password-text", function (e) {
  e.preventDefault();
  emailInput.value = smartLoginEmailInput.value;
  $(smartBoxEmailInput).slideUp();
  $(boxEmailInput).slideDown();
});

$(document).on("click", ".get-a-code", function (e) {
  e.preventDefault();
  $(smartBoxEmailInput).slideDown();
  $(boxEmailInput).slideUp();
});
$(document).on("click", ".smart-next-btn", function (e) {
  e.preventDefault();
  if ($(this).hasClass("submit__btn")) {
    // Submit
    smartLoginEmailWithOtp(e);
  } else {
    // Next
    smartloginFormEmailSubmit(e);
  }
});

$(document).on("click", "#change-username-btn", function (e) {
  e.preventDefault();
  $(smartTokenStep).slideUp();
  $(smartLoginEmailInput).prop("readonly", false);
  $(smartLoginEmailInput).val("");
  $(smartLoginEmailInput).focus();
  $(smartloginEmailBtnValue).text("Next");
  $(smartloginEmailBtn).removeClass("submit__btn");
  $(this).closest("p").slideUp();
  smartEmailFeedback.innerHTML = "";
});

$(document).on("click", ".login-resend-code-text", function (e) {
    e.preventDefault();
    el = $(this);
    $.ajax({
      url: "/login/check-username-existence",
      method: "POST",
      data: {
        username: smartLoginEmailInput.value,
      },
      headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
      },
      success: (data) => {
        if (data?.username_type == "email" || data?.username_type == "mobile") {
          smartTokenFeedback.innerText = "";
          $(".login-resend-code-text").hide(0);
          $(".code-been-sent-again").show(100);
          el.addClass("disabled");
          clearOtpInputValue();

        } else {
          console.log("Error: username type in resend code")
        }

      },
      error: (e) => {
        console.log("erorr", e);
        toggleLoadingButton(smartloginEmailBtnValue);
      },
    });
});

loginFormEmail.addEventListener('submit', e => loginFormEmailSubmit(e));
loginFormPhone.addEventListener("submit", (e) => loginFormPhoneSubmit(e));

codeBox1.forEach(el => el.addEventListener("keydown", (e) => onKeyDownEvent(1, e)));
codeBox1.forEach(el => el.addEventListener("keyup",   (e) => onKeyUpEvent(1, e)));
codeBox1.forEach(el => el.addEventListener("input",   (e) => onInputEvent(1, e)));
codeBox1.forEach(el => el.addEventListener("focus",   (e) => onFocusEvent(1)));

codeBox2.forEach(el => el.addEventListener("keydown", (e) => onKeyDownEvent(2, e)));
codeBox2.forEach(el => el.addEventListener("keyup",   (e) => onKeyUpEvent(2, e)));
codeBox2.forEach(el => el.addEventListener("input",   (e) => onInputEvent(2, e)));
codeBox2.forEach(el => el.addEventListener("focus",   (e) => onFocusEvent(2)));

codeBox3.forEach(el => el.addEventListener("keydown", (e) => onKeyDownEvent(3, e)));
codeBox3.forEach(el => el.addEventListener("keyup",   (e) => onKeyUpEvent(3, e)));
codeBox3.forEach(el => el.addEventListener("input",   (e) => onInputEvent(3, e)));
codeBox3.forEach(el => el.addEventListener("focus",   (e) => onFocusEvent(3)));

codeBox4.forEach(el => el.addEventListener("keydown", (e) => onKeyDownEvent(4, e)));
codeBox4.forEach(el => el.addEventListener("keyup",   (e) => onKeyUpEvent(4, e)));
codeBox4.forEach(el => el.addEventListener("input",   (e) => onInputEvent(4, e)));
codeBox4.forEach(el => el.addEventListener("focus",   (e) => onFocusEvent(4)));

// otp inputs
 const setOtpInputValue = () => {
  if (phoneOrEmailOTP === "email"){
    OTPdigits = codeBox1[0].value + codeBox2[0].value + codeBox3[0].value + codeBox4[0].value;
  } else if (phoneOrEmailOTP === "mobile"){
    OTPdigits = codeBox1[1].value + codeBox2[1].value + codeBox3[1].value + codeBox4[1].value;
  } else {
    console.log("#1 - The type is neither email nor phone");
  }
 }
const clearOtpInputValue = () => {
  codeBox1.forEach(el => el.value = "");
  codeBox2.forEach(el => el.value = "");
  codeBox3.forEach(el => el.value = "");
  codeBox4.forEach(el => el.value = "");
}

const getCodeBoxElement = (index) => {
  if (phoneOrEmailOTP === "email"){
    return document.querySelectorAll('.codeBox' + index)[0];
  } else if (phoneOrEmailOTP === "mobile"){
    return document.querySelectorAll('.codeBox' + index)[1];
  } else {
    console.log("#2 - The type is neither email nor phone");
  }
}

const onInputEvent = (index, event) => {
  const element = getCodeBoxElement(index);
  if (element.value.length) {
    if (element.value.length > 1) {
      element.value = element.value.substr(element.value.length - 1);
    }

    if (index !== 4) {
      getCodeBoxElement(index + 1).focus();
    } else {
      element.blur();
    }
  }
  setOtpInputValue();
}

const onKeyDownEvent = (index, event) => {
  const keyCode = event.keyCode;

  const excludedKeys = [8, 37, 39, 46];

  if (!((keyCode >= 48 && keyCode <= 57) ||
    (keyCode >= 96 && keyCode <= 105) ||
    (excludedKeys.includes(keyCode)))) {
    event.preventDefault();
  }
};

const onKeyUpEvent = (index, event) => {
  const eventCode = event.which || event.keyCode;
  if (eventCode === 8 && !event.target.value && index > 1) {
    event.preventDefault();
    getCodeBoxElement(index - 1).focus();
    getCodeBoxElement(index - 1).select();
  }
}
const onFocusEvent = (index) => {
  for (item = 1; item < index; item++) {
    const currentElement = getCodeBoxElement(item);
    if (!currentElement.value) {
        currentElement.focus();
        break;
    }
  }
}
// end otp input

const smartloginFormEmailSubmit = (e) => {
  e.preventDefault();
  smartEmailFeedback.innerText = "";


  if (smartLoginEmailInput.value.length === 0) {
    smartEmailFeedback.innerText = "Please fill the username";
    return;
  }

  if (textOnlyDigits(smartLoginEmailInput.value)) {
    if (smartLoginEmailInput.value.length < 8 || smartLoginEmailInput.value.length > 16) {
      smartEmailFeedback.innerText = "Please fill the phone correctly";
      return;
    }
  }

  toggleLoadingButton(smartloginEmailBtn);
  if (smartLoginEmailInput.value.length != 0) {
    $.ajax({
      url: "/login/check-username-existence",
      method: "POST",
      data: {
        username: smartLoginEmailInput.value,
      },
      headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
      },
      success: (data) => {
        if (data?.username_type == "non") {
          if (textIsEmail(smartLoginEmailInput.value)) {
            smartEmailFeedback.innerHTML = "Email not found, " +
                                          '<span id="change-username-btn" class="change-username-btn">Change your email</span>' +
                                          '<span class="or-btn">, Or </span><a href="/register" class="change-username-btn">Sign up</a>';
          } else {
            smartEmailFeedback.innerHTML = "Phone number not found, " +
                                          '<span id="change-username-btn" class="change-username-btn">Change your phone number</span>' +
                                          '<span class="or-btn">, Or </span><a href="/register" class="sign-up-btn">Sign up</a>';
          }
        } else if (data?.username_type == "email") {
          phoneOrEmailOTP = "email";
          $(smartLoginEmailInput).prop("readonly", true);
          $(smartTokenStep).slideDown();
          $(changeUserName).slideDown();
          $(smartloginEmailBtnValue).text("Submit");
          $(smartloginEmailBtn).addClass("submit__btn");
        } else if (data?.username_type == "mobile") {
          phoneOrEmailOTP = "mobile";
          $(smartBoxEmailInput).slideUp();
          $(boxLoginFormPhone).slideDown();
          $(phoneInput).val(smartLoginEmailInput.value);
          $(smartloginEmailBtnNext).click();
        }

        toggleLoadingButton(smartloginEmailBtn);
      },
      error: (e) => {
        console.log("erorr", e);
        toggleLoadingButton(smartloginEmailBtn);
      },
    });
  }
};
const smartLoginEmailWithOtp = (e) => {
  e.preventDefault();
  if (OTPdigits == null || OTPdigits.length === 0) {
    smartTokenFeedback.innerText = "Please fill the otp";
    return;
  }
  toggleLoadingButton(smartloginEmailBtn);

  $.ajax({
    url: "/login",
    method: "POST",
    data: {
      username: smartLoginEmailInput.value,
      email_otp: OTPdigits,
      s: window.LOGIN_SOURCE,
    },
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    success: (data) => {
      window.location.href = data?.intended;

      toggleLoadingButton(smartloginEmailBtn);
    },
    error: (e) => {
      clearOtpInputValue();
      toggleLoadingButton(smartloginEmailBtn);
      $(".code-been-sent-again").hide(10);
      smartTokenFeedback.innerText = "The token is either wrong or expired. ";
      $(".login-resend-code-text").show();
    },
  });
};

const loginFormEmailSubmit = (e) => {

  e.preventDefault();

  emailFeedback.innerText = "";
  passwordFeedback.innerText = "";

  if (emailInput.value.length === 0) {
    emailFeedback.innerText = "Please fill the email";
    return;
  }

  if (passwordInput.value.length === 0) {
    passwordFeedback.innerText = "Please fill the password";
    return;
  }

  toggleLoadingButton(loginEmailBtn);

  $.ajax({
    url: "/login",
    method: "POST",
    data: {
      username: emailInput.value,
      password: passwordInput.value,
      s: window.LOGIN_SOURCE,
    },
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    success: (data) => {
      window.location.href = data.intended;
      toggleLoadingButton(loginEmailBtn);
    },
    error: () => {
      toggleLoadingButton(loginEmailBtn);
      $(passwordFeedback).html("Incorrect email or password");
    },
  });
};

const loginFormPhoneSubmit = (e) => {
  e.preventDefault();

  if (loginPhoneStep === "phone") {
    selectedUserId = undefined;
    checkUsername();
  }

  if (loginPhoneStep === "token") {
    checkToken();
  }
};

const checkUsername = (selectedUser) => {
  phoneFeedback.innerText = "";

  if (phoneInput.value.length === 0) {
    phoneFeedback.innerText = "Please fill the phone";
    return;
  }

  toggleLoadingButton(loginPhoneBtn);

  $.ajax({
    url: "/login/check-username",
    method: "POST",
    data: {
      username: phoneInput.value,
      selected_user_id: selectedUser,
    },
    success: (data) => {
      toggleLoadingButton(loginPhoneBtn);

      if (data.type != "phone") {
        phoneFeedback.innerText =
          "Couldn't find any account with this phone number";
      } else if (!data.is_valid) {
        if (data.connected_users.length > 0) {
          renderAccountCards(data.connected_users);
          $(multipleUsersStep).slideDown();
          $(phoneStep).slideUp();
          $(loginPhoneBtn).hide();
        } else {
          phoneFeedback.innerText =
            "Couldn't find any account with this phone number";
        }
      } else {
        if (!data.otp_sent) {
          if (data.otp_available_in < 0) {
            phoneFeedback.innerText = "Please try again";
          } else {
            phoneFeedback.innerText =
              "Please try again in " + data.otp_available_in + " seconds.";
          }
          $(multipleUsersStep).slideUp();
          $(phoneStep).slideDown();
          $(loginPhoneBtn).show();
        } else {
          loginPhoneStep = "token";
          loginPhoneBtn.querySelector(".button__text").innerText = "Log In";
          $(codeSentMessage).html(
            "The code sent to " +
              maskPhone(phoneInput.value) +
              ", <a href='javascript:void(0)' id='change-phone'>Change your Number</a>"
          );
          $(phoneStep).slideUp();
          $(multipleUsersStep).slideUp();
          $(tokenStep).slideDown();
          $(loginPhoneBtn).show();
          startInterval();
        }
      }
    },
    error: () => {
      $(multipleUsersStep).slideUp();
      $(phoneStep).slideDown();
      $(loginPhoneBtn).show();
      toggleLoadingButton(loginPhoneBtn);
      phoneFeedback.innerText = "Please try again";
    },
  });
};

const checkToken = () => {
  if (OTPdigits == null || OTPdigits.length === 0) {
    tokenFeedback.innerText = "Please fill the token";
    return;
  }

  tokenFeedback.innerText = "";
  toggleLoadingButton(loginPhoneBtn);

  $.ajax({
    url: "/login",
    method: "POST",
    data: {
      username: phoneInput.value,
      password: OTPdigits,
      selected_user_id: selectedUserId,
      s: window.LOGIN_SOURCE,
    },
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    success: (data) => {
      window.location.href = data.intended;
      toggleLoadingButton(loginPhoneBtn);
    },
    error: () => {
      toggleLoadingButton(loginPhoneBtn);
      tokenFeedback.innerText = "The token is either wrong or expired";
    },
  });
};

const startInterval = () => {
  timerInterval = setInterval(function () {
    if (timer > 0) {
      timer--;
    }

    if (timer === 0) {
      $("#retry-otp").html(
        "<span>Didn't receive the code? <a href='javascript:void' class='resend-otp'>Resend sms</a><span>"
      );
    }

    if (timer > 0) {
      $("#retry-otp").html(
        "<span>Didn't get the code? You can retry after " +
          timer +
          " seconds.<span>"
      );
    }
  }, 1000);
};

$(document).on("click", ".resend-otp", function () {
  $("#retry-otp").hide();
  tokenFeedback.innerText = "";
  smartTokenFeedback.innerText = "";
  $.ajax({
    method: "POST",
    url: "/login/resend-otp",
    data: {
      username: phoneInput.value,
    },
  })
    .done(function (data) {
      if (data.status) {
        message("notice", "Sent the sms");
      } else {
        message("error", "Please wait a few minutes before you try again");
      }
      timer = defaultTimer;
      setTimeout(function () {
        $("#retry-otp").show();
      }, 1000);
    })
    .fail(function (e) {
      message("error", "Please wait a few minutes before you try again");
      timer = defaultTimer;
      setTimeout(function () {
        $("#retry-otp").show();
      }, 1000);
    });
});

$(document).on("click", "#change-phone", function () {
  phoneInput.value = "";

  $(tokenStep).slideUp();
  $(phoneStep).slideDown();

  loginPhoneStep = "phone";
  clearInterval(timerInterval);
  timer = defaultTimer;
});

const toggleLoadingButton = (el) => {
  el.classList.toggle("button--loading");
  el.toggleAttribute("disabled");
};

const message = (type, message) => {
  if (type === "error") {
    $.growl.error({
      title: "",
      message: message,
      location: "tr",
    });
  } else {
    $.growl.notice({
      title: "",
      message: message,
      location: "tr",
    });
  }
};

const maskPhone = (phone) => {
  return phone.substr(0, 2) + "*****" + phone.substr(-4);
};

const textIsEmail = (text) => {
  const re = new RegExp("[A-Za-z\@]");
  return re.test(text);
};

const textOnlyDigits = (text) => {
  const re = new RegExp("[A-Za-z\@]");
  return !re.test(text);
};

const renderAccountCards = (users) => {
  let cards = "";

  users.forEach((user) => {
    cards +=
      '<button class="account-card" data-id="' +
      user.id +
      '" type="button">\
            <div class="email">' +
      user.email +
      "</div>\
        </button>";
  });

  $(accountCards).html(cards);
};

$(document).on("click", ".account-card", function () {
  selectedUserId = $(this).data("id");
  toggleLoadingButton($(this)[0]);
  toggleDisableOtherAccountCards($(this).index());
  checkUsername($(this).data("id"));
});

const toggleDisableOtherAccountCards = (exceptIndex) => {
  $(accountCards)
    .find(".account-card")
    .each(function (index) {
      if (exceptIndex !== index) this.toggleAttribute("disabled");
    });
};
